import {makeStyles} from "@material-ui/styles";

export default makeStyles(() => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
      padding: '4px',
      fontSize: '12px',
    }
  }
}))

export const useTableRowStyles = makeStyles(() => ({
  root: {
    '& > *': {
      padding: '4px',
      fontSize: '12px',
    }
  },
  rowButtons: {
    '& button': {
      marginRight: '.5rem'
    }
  },
  seatGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 8px)',
    gap: 4,
    justifyContent: 'center',
    marginTop: 4,
  },
  seatDot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    display: 'inline-block',
    opacity: 0.9,
  },
  seatDotFree: {
    background: '#22c55e',
  },
  seatDotReserved: {
    background: '#ef4444',
  },

  /* Load factor bar */
  loadWrap: {
    width: 140,
    height: 10,
    borderRadius: 9999,
    background: '#e5e7eb',
    overflow: 'hidden',
    margin: '0 auto 4px',
  },
  loadFill: {
    height: '100%',
    background: '#9ca3af',
  },
  loadLabel: {
    fontSize: 12,
    fontWeight: 600 as const,
  }
}))
